export const tryCatchJsonParse = (key, fallback)=>{
    try {
        return JSON.parse(localStorage.getItem(key))
        
    } catch (error) {
        return fallback
        
    }
}